// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6020":"css/app.7025","6710":"css/admin-app.7025"}[chunkId] + ".css";
};